import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { CoreModule } from '../../core/core.module';
import { BuscadorSolicitudService } from '../buscadores/solicitudes/buscador-solicitud.service';
import { AnulacionEditComponent } from './anulacion/anulacion-edit.component';
import { AnulacionService } from './anulacion/anulacion.service';
import { DestinoControlPopupComponent } from './components/popup/destinoControl/destinoControlPopup.component';
import { PartidaPreduaPopupComponent } from './components/popup/partidaPredua/partidaPreduaPopup.component';
import { PuntoControlPopupComponent } from './components/popup/puntoControl/puntoControlPopup.component';
import { SolicitudService } from './datosbasicos/datosbasicos.service';
import { SolicitanteDetailComponent } from './datosbasicos/solicitante/solicitante-detail.component';
import { SolicitudEditComponent } from './datosbasicos/solicitud-edit.component';
import { DocumentosEditComponent } from './documentos/documentos-edit.component';
import { DocumentosListComponent } from './documentos/documentos-list.component';
import { DocumentosService } from './documentos/documentos.service';
import { EnvioComponent } from './envio/envio.component';
import { EnvioService } from './envio/envio.service';
import { InspeccionesComponent } from './inspecciones/inspecciones.component';
import { InspeccionesService } from './inspecciones/inspecciones.service';
import { PreduaEditComponent } from './predua/predua-edit.component';
import { PreduaService } from './predua/predua.service';
import { PreviaInspectorEditComponent } from './previaInspector/previaInspector-edit.component';
import { PreviaInspectorService } from './previaInspector/previaInspector.service';
import { EmbalajeEditComponent } from './productos/embalajes-edit.component';
import { ProductoEditComponent } from './productos/productos-edit.component';
import { ProductosSolicitudListComponent } from './productos/productos-list.component';
import { ProductosService } from './productos/productos.service';
import { SeguimientoEditComponent } from './seguimiento/seguimiento-edit.component';
import { SeguimientoListComponent } from './seguimiento/seguimiento-list.component';
import { SeguimientoService } from './seguimiento/seguimiento.service';
import { TasasComponent } from './tasas/tasas.component';
import { TasasService } from './tasas/tasas.service';
import { TipoSolicitudListComponent } from './tipossolicitudes/tiposolicitud-list.component';
import { BuscadorOperadorListComponent } from './components/popup/operador/buscadoroperador-list.component';
import { BuscadorOperadorService } from './components/popup/operador/buscadoroperador.service';
import { SolicitudesRoutingModule } from './solicitudes-routing.module';
import { LaboratorioService } from './laboratorio/laboratorio.service';
import { LaboratorioWrapperComponent } from './laboratorio/laboratorio-wrapper/laboratorio-wrapper.component';
import { LaboratorioDatosComponent } from './laboratorio/laboratorio-datos/laboratorio-datos.component';
import { LaboratorioEnvioMuestrasComponent } from './laboratorio/laboratorio-enviomuestras/laboratorio-enviomuestras.component';
import { LaboratorioResultadoEnvioMuestrasComponent } from './laboratorio/laboratorio-resultadoenviomuestras/laboratorio-resultadoenviomuestras.component';
import { LaboratorioDocumentosListComponent } from './laboratorio/laboratorio-documentos-list/laboratorio-documentos-list.component';
import { LaboratorioDocumentosEditComponent } from './laboratorio/laboratorio-documentos-edit/laboratorio-documentos-edit.component';
import { RechazoParcialComponent } from './inspecciones/rechazoparcial.component';
import { FrSanidadExtComponent } from './inspecciones/fr-sanidad-ext/fr-sanidad-ext.component';
import { BuscadorCodigoConfeccionListComponent } from './components/popup/codigoConfeccion/buscador-codigoconfeccion-list.component';
import { ImportadorLugarDestinoWrapperComponent } from './importador-lugardestino/importador-lugardestino-wrapper/importador-lugardestino-wrapper.component';
import { ImportadorComponent } from './importador-lugardestino/importador/importador.component';
import { LugarDestinoComponent } from './importador-lugardestino/lugardestino/lugardestino.component';
import { ImportadorLugarDestinoService } from './importador-lugardestino/importador-lugardestino.service';

@NgModule({
    declarations: [
        SolicitudEditComponent,
        SolicitanteDetailComponent,
        TipoSolicitudListComponent,
        ProductosSolicitudListComponent,
        ProductoEditComponent,
        EmbalajeEditComponent,
        PuntoControlPopupComponent,
        DestinoControlPopupComponent,
        PartidaPreduaPopupComponent,
        AnulacionEditComponent,
        PreviaInspectorEditComponent,
        EnvioComponent,
        TasasComponent,
        InspeccionesComponent,
        RechazoParcialComponent,
        PreduaEditComponent,
        DocumentosListComponent,
        DocumentosEditComponent,
        SeguimientoEditComponent,
        SeguimientoListComponent,
        BuscadorOperadorListComponent,
        BuscadorCodigoConfeccionListComponent,
        LaboratorioWrapperComponent,
        LaboratorioDatosComponent,
        LaboratorioEnvioMuestrasComponent,
        LaboratorioResultadoEnvioMuestrasComponent,
        LaboratorioDocumentosListComponent,
        LaboratorioDocumentosEditComponent,
        FrSanidadExtComponent,
        ImportadorLugarDestinoWrapperComponent,
        ImportadorComponent,
        LugarDestinoComponent,
    ],
    exports: [
        PuntoControlPopupComponent,
        DestinoControlPopupComponent,
        PartidaPreduaPopupComponent,
        BuscadorOperadorListComponent,
        BuscadorCodigoConfeccionListComponent,
    ],
    imports: [CoreModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, SolicitudesRoutingModule],
    providers: [
        BuscadorSolicitudService,
        SolicitudService,
        EnvioService,
        AnulacionService,
        PreviaInspectorService,
        TasasService,
        InspeccionesService,
        PreduaService,
        ProductosService,
        DocumentosService,
        SeguimientoService,
        BuscadorOperadorService,
        LaboratorioService,
        ImportadorLugarDestinoService,
    ],
})
export class SolicitudesModule {}
